import { HemisphereLight, DirectionalLight } from 'three'
const PI = Math.PI

const applyBasicLighting = scene => {
  const hemisphereLight = new HemisphereLight(0xffffff, 0x666666, 0.4 * PI)
  hemisphereLight.position.set(0, -1, 0)
  scene.add(hemisphereLight)
}

const applyDefaultLighting = scene => {
  const bottomLight = new DirectionalLight(0x666666, 0.8 * PI)
  bottomLight.position.set(0, -1, 0)
  scene.add(bottomLight)

  const bottomRightLight = new DirectionalLight(0xffffff, 0.1 * PI)
  bottomRightLight.castShadow = false
  bottomRightLight.position.set(1, -1, 1)
  scene.add(bottomRightLight)

  const bottomLeftLight = new DirectionalLight(0xffffff, 0.3 * PI)
  bottomLeftLight.castShadow = false
  bottomLeftLight.position.set(-1, -1, -1)
  scene.add(bottomLeftLight)

  const bottomMiddleLight = new DirectionalLight(0xffffff, 1.0 * PI)
  bottomMiddleLight.castShadow = false
  bottomMiddleLight.position.set(0.3, 1, 0.3)
  scene.add(bottomMiddleLight)
}

export { applyBasicLighting, applyDefaultLighting }
